var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTags
    ? _c(
        "div",
        { staticClass: "tags" },
        [
          _c(
            "el-breadcrumb",
            {
              staticClass: "breadcrumb-cls",
              attrs: { "separator-class": "el-icon-arrow-right" },
            },
            [
              _vm.getUser.hasSiteBind && !_vm.getUser.isSecurityAuditor
                ? _c(
                    "el-breadcrumb-item",
                    {
                      staticClass: "breadcrumb-home-item",
                      attrs: { to: { name: "businessHome" } },
                    },
                    [
                      _c("img", {
                        staticClass: "menu-icon-cls",
                        attrs: {
                          src: require("@/assets/img/icon-menu1-2.svg"),
                          width: "100%",
                        },
                      }),
                      _c("img", {
                        staticClass: "menu-icon-hover-cls",
                        attrs: {
                          src: require("@/assets/img/icon-menu1-3.svg"),
                          width: "100%",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("home")))]),
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.routes, function (item, index) {
                return _c(
                  "el-breadcrumb-item",
                  { key: index, attrs: { to: { name: item } } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t(_vm.getRouteByName(item).meta.title)) +
                        "\n          "
                    ),
                    item == "settingHome" && _vm.getUser.userType == "1"
                      ? _c("GuidanceTooltip", {
                          staticClass: "tip-icon",
                          attrs: {
                            content: _vm.$t("settingHomeTipHtml"),
                            size: 18,
                            iconSize: 14,
                            jumpLink: _vm.$t("settingHomeTipLink"),
                          },
                        })
                      : _vm._e(),
                    item == "insights"
                      ? _c("GuidanceTooltip", {
                          staticClass: "tip-icon",
                          attrs: {
                            content: _vm.$t(
                              `kee_video_tip_${_vm.getUser.userType}`
                            ),
                            size: 18,
                            iconSize: 14,
                            jumpLink: _vm.$t(
                              `kee_video_link_${_vm.getUser.userType}`
                            ),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm.showClientName
            ? _c(
                "span",
                {
                  staticClass: "tags-client-name-hint",
                  attrs: { title: _vm.getSite.clientName },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("FORM_LABEL_clientName")) +
                      ":\n    "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bolder",
                        color: "#00338D",
                      },
                    },
                    [_vm._v(_vm._s(_vm.getSite.clientName))]
                  ),
                ]
              )
            : _vm._e(),
          _vm.getUser.userType === "1"
            ? _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    trigger: "hover",
                    "popper-class": "tag-engagement-popper-cls",
                  },
                },
                [
                  _c("div", { staticClass: "engagement-slot-info" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("site_code")) + ": "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(_vm._s(_vm.engagementInfo.code || "-")),
                      ]),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("site_type")) + ": "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(_vm._s(_vm.engagementInfo.type || "-")),
                      ]),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("site_status")) + ": "),
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(_vm._s(_vm.engagementInfo.status || "-")),
                      ]),
                    ]),
                    _c("div", {
                      staticClass: "warning",
                      domProps: {
                        innerHTML: _vm._s(_vm.engagementInfo.notice),
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$route.path === "/client",
                          expression: "$route.path === '/client'",
                        },
                      ],
                      staticClass: "engagement-info",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [
                      false
                        ? _c(
                            "div",
                            {
                              class: [
                                "info-text-area",
                                "animation-" +
                                  _vm.engagementInfo.animationTimeType,
                              ],
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("site_code")) +
                                    ":" +
                                    _vm._s(_vm.engagementInfo.code || "-")
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("site_type")) +
                                    ":" +
                                    _vm._s(_vm.engagementInfo.type || "-")
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("site_status")) +
                                    ":" +
                                    _vm._s(_vm.engagementInfo.status || "-")
                                ),
                              ]),
                              _c("span", {
                                staticClass: "warning",
                                domProps: {
                                  innerHTML: _vm._s(_vm.engagementInfo.notice),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "attention-tips" },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-name": "information",
                              "icon-color": "#fd349c",
                              size: 16,
                            },
                          }),
                          _vm._v(
                            "\n        " + _vm._s(_vm.siteTips) + "\n      "
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }